import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
} from 'chart.js';
import { Bar, Doughnut } from 'react-chartjs-2';
import { cn } from 'utils';
import styles from './dashboard.module.scss';
import Select from 'components/Select';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
);

export const options = {
    plugins: {
        title: {
            display: false,
        },
        tooltip: {
            enabled: true,
            backgroundColor: "#FFFFFF",
            titleColor: "#1D2630",
            bodyColor: "#1D2630",
            fontSize: 28,
            usePointStyle: true,
            callbacks: {
                label: (tooltipItem) => {
                    // console.log({ tooltipItem, data })
                    return `$${tooltipItem.raw}`
                },
                title: (tooltipItem) => {
                    return `${tooltipItem?.[0]?.label} 2024`
                }
            },
        }
    },
    responsive: true,
    interaction: {
        mode: 'index',
        intersect: false,
    },
    scales: {
        x: {
            stacked: true,
        },
        y: {
            stacked: true,
        },
    },
};

const labels = ['Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const data = {
    labels,
    datasets: [
        {
            label: 'Dataset 1',
            data: [2000, 0, 4500, 4500, 3000, 2300, 8000, 12000, 1300, 5500],
            backgroundColor: '#FFC7A5',
            stack: 'Stack 0',
            pointStyle: "circle"
        },
        {
            label: 'Dataset 2',
            data: [4500, 4500, 5000, 5500, 5000, 4000, 5000, 9000, 12000, 2000],
            backgroundColor: '#E7730A',
            stack: 'Stack 0',
            pointStyle: "circle"
        },
    ],
};

const doughnutChartData = {
    datasets: [
        {
            label: ['# of Votes'],
            data: [10, 40, 30, 20],
            backgroundColor: [
                '#DC2626',
                '#0067A7',
                '#983A00',
                '#E58A00',
            ],
            pointStyle: "circle"
        },
    ],
};

const doughnutOptions = {
    tooltip: {
        usePointStyle: true,
        callbacks: {
            title: (tooltipItems) => {
                console.log("tooltipItems", tooltipItems);
                return tooltipItems[0].label
            },
            label: (tooltipItem) => tooltipItem.raw,
        },
    },
}

const DashboardCharts = () => {
    return (
        <div className='container-fluid padding-0'>
            <div className={cn('row g-2', styles.chartsContainer)}>
                <div className={cn('col-lg-8 col-12')}>
                    <BarChartCard />
                </div>
                <div className={cn('col-lg-4 col-12')}>
                    <DoughnutChartCard />
                </div>
            </div>
        </div>
    )
}

const BarChartCard = () => {
    return (
        <div className={styles.chartCard}>
            <div className={styles.header}>
                <p className={styles.title}>Payroll Cost Overview</p>
                <Select
                    value={'Liabilities (YTD)'}
                    options={[
                        {
                            label: 'Liabilities (YTD)',
                            value: 'Liabilities (YTD)',
                        }
                    ]}
                    color='white'
                />
            </div>
            <Bar options={options} data={data} />
            <div className={styles.barChartFooter}>
                <div className={styles.legend}>
                    <div style={{ backgroundColor: '#E7730A' }} className={styles.color} />
                    <p>Expense</p>
                </div>
                <div className={styles.legend}>
                    <div style={{ backgroundColor: '#FFC7A5' }} className={styles.color} />
                    <p>Pending Payment</p>
                </div>
            </div>
        </div>
    )
}

const DoughnutChartCard = () => {

    const summary = [
        {
            label: 'Liabilities (YTD)',
            value: '$181.34',
            color: '#1D2630'
        },
        {
            label: 'Gross Pay (YTD)',
            value: '$37.13',
            color: '#CF272D'
        },
        {
            label: 'Taxes (ER) (YTD)',
            value: '$181.34',
            color: '#983A00'
        },
        {
            label: 'Benefits (ER) (YTD)',
            value: '$37.13',
            color: '#0067A7'
        },
    ]

    return (
        <div className={styles.chartCard}>
            <div className={styles.header}>
                <p className={styles.title}>Payroll Summary</p>
                <p className={styles.secondaryTitle}>View report</p>
            </div>
            <div className={styles.doughnutCharConainer}>
                <Doughnut options={doughnutOptions} data={doughnutChartData} />
            </div>
            <div className={styles.doughnutFooter}>
                <Select
                    color='white'
                    value='1'
                    options={[
                        {
                            label: 'From 1-31 Feb, 2025',
                            value: '1'
                        }
                    ]}
                />
                <div className={cn('container-fluid padding-0')}>
                    <div className={cn('row g-3', styles.summaryDetails)}>
                        {summary.map(({
                            label,
                            value,
                            color
                        }, index) => {
                            return (
                                <div key={index} className={cn('col-6')}>
                                    <div className={styles.card}>
                                        <p className={styles.label}><span style={{ backgroundColor: color }} />{label}</p>
                                        <p className={styles.value}>{value}</p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DashboardCharts;